import React, {useEffect, useState} from "react";
import { Helmet } from "react-helmet";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Alert from "@material-ui/lab/Alert";
import { selectCities } from "const";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
import Person from "@material-ui/icons/Person";
import Password from "@material-ui/icons/Lock";
// layout
import Signup from "cabinet/layout/Signup";
// core components
import Button from "cabinet/components/ui/CustomButtons/Button";
import CardBody from "cabinet/components/ui/Card/CardBody";
import CardHeader from "cabinet/components/ui/Card/CardHeader";
import CardFooter from "cabinet/components/ui/Card/CardFooter";
import CustomInput from "cabinet/components/ui/CustomInput/CustomInput";
import styles from "assets/jss/material-kit-react/views/signupPage";
import Select from "cabinet/components/ui/Select";

import Grid from "@material-ui/core/Grid";
// store
import { useDispatch, useSelector } from "react-redux";
// router
import { useHistory, Link } from "react-router-dom";

// validate function
import { Box } from "@material-ui/core";

import {
	SelectBlock,
	ControlBlock,
	Checkbox,
	FormControlLabel,
	InputBox,
	CheckboxCityBox,
} from "./styles";
import { registrationUser } from "../../store/actions/userActions";
import {RegistrationFormFields} from "./RegistrationFormFields";
import {ErrorsAlertBox} from "./ErrorsAlertBox";
import {validateFieldIsRequired} from "../../../utils/validate";
import Preloader from "../../components/Preloader";

const useStyles = makeStyles(styles);


const SignUpPage = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const { error } = useSelector((state) => state.client.user);
	const [isLoading, setLoading] = useState(false);
	const [isDisableForm, setDisableForm] = useState(true);
	const [confirmPassword, setConfirmPassword] = useState("");
	const [formFields, setFormFields] = useState(RegistrationFormFields.DefaultInit());
	const [, setCardAnimation] = useState("cardHidden");
	setTimeout(() => {
		setCardAnimation("");
	}, 700);

	const sendForm = (e) => {
		setLoading(true);
		e.preventDefault();
		e.stopPropagation();

		const validationResult = formFields.validate();

		setFormFields(validationResult.form);

		if (!validationResult.isValid) {
			setLoading(false);
			return;
		}

		const sendData = validationResult.form.formData();
		dispatch(registrationUser(sendData)).then(() => {
			setLoading(false);
			setFormFields(formFields.reset());
			history.push("/");
		}).catch(e => {
			setLoading(false);
		});
	};

	const classes = useStyles();

	const firstNameField = formFields.find("name");
	const lastNameField = formFields.find("lastName");
	const yearOfBirthField = formFields.find("yearOfBirth");
	const phoneField = formFields.find("phone");
	const regionField = formFields.find("region");
	const cityField = formFields.find("city");
	const isCityInputField = formFields.find("isCityInput");
	const employmentField = formFields.find("employment");
	const jobPositionField = formFields.find("jobPosition");
	const classField = formFields.find("class");
	const isClassTeacherField = formFields.find("isClassTeacher");
	const countOfStudentsField = formFields.find("countOfStudents");
	const emailField = formFields.find("email");

	const passwordField = formFields
		.find("password")
		.withAdditionalValidation(() => {
			if (confirmPassword !== passwordField.value) {
				return ["Паролі не збігаються"];
			}

			return [];
		});

	const personalDataField = formFields.find("personalData");

	const isCityDisabled = !regionField.value;
	const citiesOptions = regionField.value !== null && selectCities.cities[regionField.value.value];

	const onChangeTextInput = (field, newValue) => {
		const newForm = formFields.updateField(field, newValue, true);
		setFormFields(newForm);
	};

	useEffect(() => {
		setFormFields(formFields.validateField(passwordField));
	}, [confirmPassword]);

	if (isLoading) {
		return <Preloader />;
	}

	if (isDisableForm) {
		return (
			<Signup>
				<div id="worning-notification">
					<b>Шановні колеги!</b>
					<br/>Нашу навчальну платформу покращено.
					<br/>Тепер ви можете проходити наш курс "Навчання з попередження ризиків від вибухонебезпечних предметів" (EORE) на платформі Prometheus за посиланням - <a href="https://courses.prometheus.org.ua/courses/UDA">https://courses.prometheus.org.ua/courses/UDA</a>
					<br/>Цей курс буде діяти на постійній основі.
					<br/>Відтепер він буде більш зручним та доступним.
					<br/>Дякуємо вам за терпіння!
					<br/>Починаємо з 28.07.2022
				</div>
		</Signup>);
	}

	return (
		<Signup>
			<Helmet>
				<title>Реєстрація | Навчальна платформа</title>
			</Helmet>
			<form className={classes.form}>
				<CardHeader color="primary" className={classes.cardHeader}>
					<h4>Реєстрація</h4>
					<p>Реєстрація починається 1 жовтня 2020 року</p>
				</CardHeader>
				<CardBody>
					<Grid container spacing={3}>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<CustomInput
									labelText="Ім'я"
									id="first"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										type: "text",
										endAdornment: (
											<InputAdornment position="end">
												<Person className={classes.inputIconsColor} />
											</InputAdornment>
										),
										name: "name",
										value: firstNameField.value,
										onChange: (e) => onChangeTextInput(firstNameField, e.target.value),
									}}
								/>
								<ErrorsAlertBox show={!firstNameField.isValid()}>{firstNameField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<CustomInput
									labelText="Прізвище"
									id="second"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										type: "text",
										endAdornment: (
											<InputAdornment position="end">
												<Person className={classes.inputIconsColor} />
											</InputAdornment>
										),
										name: "lastName",
										value: lastNameField.value,
										onChange: (e) => onChangeTextInput(lastNameField, e.target.value),
									}}
								/>
								<ErrorsAlertBox show={!lastNameField.isValid()}>
									{lastNameField.topError()}
								</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Alert severity="warning">
							Для отримання сертифікату будь ласка вказуйте правильне прізвище та
							ім&#39;я українською мовою.
						</Alert>
						<Grid item md={12} sm={12} xs={12}>
							<InputBox>
								<CustomInput
									labelText="Email"
									id="email"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										type: "email",
										endAdornment: (
											<InputAdornment position="end">
												<Email className={classes.inputIconsColor} />
											</InputAdornment>
										),
										name: "email",
										value: emailField.value,
										onChange: (e) => onChangeTextInput(emailField, e.target.value),
									}}
								/>
								<ErrorsAlertBox show={!emailField.isValid()}>{emailField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<CustomInput
									labelText="Пароль"
									id="pass"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										type: "password",
										endAdornment: (
											<InputAdornment position="end">
												<Password className={classes.inputIconsColor} />
											</InputAdornment>
										),
										autoComplete: "off",
										name: "password",
										value: passwordField.value,
										onChange: (e) => onChangeTextInput(passwordField, e.target.value),
									}}
								/>
								<ErrorsAlertBox show={!passwordField.isValid()}>{passwordField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<CustomInput
									labelText="Підтвердіть пароль"
									id="confirm-pass"
									formControlProps={{
										fullWidth: true,
									}}
									inputProps={{
										type: "password",
										endAdornment: (
											<InputAdornment position="end">
												<Password className={classes.inputIconsColor} />
											</InputAdornment>
										),
										autoComplete: "off",
										name: "confirm-password",
										value: confirmPassword,
										onChange: (e) => setConfirmPassword(e.target.value),
									}}
								/>
								<ErrorsAlertBox show={!passwordField.isValid()}>{passwordField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<ControlBlock>
									<CustomInput
										labelText="Рік народження"
										id="age"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											type: "number",
											name: "yearOfBirth",
											value: yearOfBirthField.value,
											onChange: (e) => onChangeTextInput(yearOfBirthField, e.target.value),
										}}
									/>
								</ControlBlock>
								<ErrorsAlertBox show={!yearOfBirthField.isValid()}>{yearOfBirthField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<ControlBlock>
									<CustomInput
										labelText="Номер телефону у Viber"
										type="tel"
										id="phone"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											type: "tel",
											name: "phone",
											value: phoneField.value,
											onChange: (e) => onChangeTextInput(phoneField, e.target.value),
										}}
									/>
								</ControlBlock>
								<ErrorsAlertBox show={!phoneField.isValid()}>{phoneField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<SelectBlock>
									<Select
										label="Область"
										id="region"
										name="region"
										placeholder="Виберіть область"
										noOptionsMessage={() => "Нічого не знайдено"}
										options={selectCities.regions}
										value={regionField.value}
										onChange={(select) => onChangeTextInput(regionField, select)}
									/>
								</SelectBlock>
								<ErrorsAlertBox show={!regionField.isValid()}>{regionField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								{isCityInputField.value ? (
									<SelectBlock style={{ marginBottom: 0 }}>
										<CustomInput
											labelText="Місто"
											id="city"
											formControlProps={{
												fullWidth: true,
												style: {
													marginBottom: 8,
												},
											}}
											inputProps={{
												value:cityField.value?.label,
												onChange: (e) => onChangeTextInput(cityField, {
													label: e.target.value,
													value: `${regionField.value}-${e.target.value}`,
												}),
											}}
										/>
									</SelectBlock>
								) : (
									<SelectBlock>
										<Select
											label="Місто"
											id="city"
											name="city"
											noOptionsMessage={() => "Нічого не знайдено"}
											isDisabled={isCityDisabled}
											options={citiesOptions}
											value={cityField.value}
											placeholder={
												isCityDisabled ? "Спочатку виберіть область!" : "Виберіть місто"
											}
											onChange={(select) => onChangeTextInput(cityField, select)}
										/>
									</SelectBlock>
								)}
								<ErrorsAlertBox show={!cityField.isValid()}>{cityField.topError()}</ErrorsAlertBox>
								<CheckboxCityBox
									label="Мого міста немає у списку"
									disabled={isCityDisabled}
									control={
										<Checkbox
											checked={isCityInputField.value}
											color="primary"
											onChange={(e, value) => onChangeTextInput(isCityInputField, value)}
										/>
									}
								/>
							</InputBox>
						</Grid>
						<Grid item md={6} sm={12} xs={12}>
							<InputBox>
								<ControlBlock>
									<CustomInput
										id="employment"
										labelText="Місце роботи"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											name: "employment",
											value: employmentField.value,
											onChange: (e) => onChangeTextInput(employmentField, e.target.value),
										}}
									/>
								</ControlBlock>
								<ErrorsAlertBox show={!employmentField.isValid()}>{employmentField.topError()}</ErrorsAlertBox>
							</InputBox>
							<InputBox>
								<ControlBlock>
									<CustomInput
										id="jobPosition"
										labelText="Посада"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											name: "jobPosition",
											value: jobPositionField.value,
											onChange: (e) => onChangeTextInput(jobPositionField, e.target.value),
										}}
									/>
								</ControlBlock>
								<ErrorsAlertBox show={!jobPositionField.isValid()}>{jobPositionField.topError()}</ErrorsAlertBox>
							</InputBox>
						</Grid>
					</Grid>

					<Grid item xs={12} component={Box} padding={3} />

					<FormControlLabel
						control={
							<Checkbox
								color="primary"
								checked={isClassTeacherField.value}
								onChange={(e, value) => {
									onChangeTextInput(isClassTeacherField, value);

									// If person is class teacher then we should additionally validate additional fields
									const newValidations = value ? [validateFieldIsRequired] : [];

									setFormFields(formFields.setValidationsFor(classField, newValidations));
									setFormFields(formFields.setValidationsFor(countOfStudentsField, newValidations));
								}}
								name="isClassTeacher"
							/>
						}
						label="Класний керівник"
					/>
					{isClassTeacherField.value && (
						<Grid container spacing={3}>
							<Grid item lg={6}>
								<InputBox>
									<CustomInput
										labelText="Клас"
										id="class"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											type: "text",
											name: "class",
											value: classField.value,
											onChange: (e) => onChangeTextInput(classField, e.target.value),
										}}
									/>
									<ErrorsAlertBox show={!classField.isValid()}>{classField.topError()}</ErrorsAlertBox>
								</InputBox>
							</Grid>
							<Grid item lg={6}>
								<InputBox>
									<CustomInput
										labelText="Кількість учнів"
										id="countOfStudents"
										formControlProps={{
											fullWidth: true,
										}}
										inputProps={{
											type: "number",
											name: "countOfStudents",
											value: countOfStudentsField.value,
											onChange: (e) => onChangeTextInput(countOfStudentsField, e.target.value),
										}}
									/>
									<ErrorsAlertBox show={!countOfStudentsField.isValid()}>{countOfStudentsField.topError()}</ErrorsAlertBox>
								</InputBox>
							</Grid>
						</Grid>
					)}
					<InputBox>
						<FormControlLabel
							styles={{ fontSize: "11px" }}
							control={
								<Checkbox
									color="primary"
									checked={personalDataField.value}
									onChange={(e, value) => onChangeTextInput(personalDataField, value)}
									name="personalData"
								/>
							}
							label="Згода на обробку персональних даних"
						/>
						<ErrorsAlertBox  show={!personalDataField.isValid()}>{personalDataField.topError()}</ErrorsAlertBox>
					</InputBox>
				</CardBody>
				{error && <Alert severity="error">{error}</Alert>}
				<CardFooter className={classes.cardFooter}>
					<Button
						disabled={isLoading}
						simple
						color="primary"
						size="lg"
						onClick={sendForm}>
						Реєстрація
					</Button>
					<Grid container>
						<Grid item xs={12} />
						<Grid item className={classes.textAlignRight} xs={12}>
							<Link to="/">Вхід</Link>
						</Grid>
					</Grid>
				</CardFooter>
			</form>
		</Signup>
	);
};

export default SignUpPage;
